var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerIconThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Ico_Custom_Customer",
    width: 43.384,
    height: 58.879,
    "data-name": "Ico Custom Customer",
    viewBox: "0 0 43.384 58.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#006274}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1988",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1988",
    transform: "translate(8.78 10.687)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1993",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1993",
    transform: "translate(8.78 19.984)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1996",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1996",
    transform: "translate(8.78 29.28)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1989",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1989",
    transform: "translate(18.077 10.687)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1992",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1992",
    transform: "translate(18.077 19.984)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1995",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1995",
    transform: "translate(18.077 29.28)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1990",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1990",
    transform: "translate(27.373 10.687)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1991",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1991",
    transform: "translate(27.373 19.984)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_1994",
    cx: 3.099,
    cy: 3.099,
    r: 3.099,
    className: "prefix__cls-1",
    "data-name": "Ellipse 1994",
    transform: "translate(27.373 29.28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rechteck_135019",
    "data-name": "Rechteck 135019",
    style: {
      stroke: "#006274",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28.384a15 15 0 0 1 15 15v43.879H0V0z",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5.75h26.884A14.25 14.25 0 0 1 42.634 15v42.379a.75.75 0 0 1-.75.75H1.5a.75.75 0 0 1-.75-.75V1.5A.75.75 0 0 1 1.5.75z",
    style: {
      fill: "none"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rechteck_135415",
    d: "M0 0H11.569V16.569H0z",
    className: "prefix__cls-1",
    "data-name": "Rechteck 135415",
    transform: "translate(15.908 41.525)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIconThin);
export default __webpack_public_path__ + "static/media/customerIconThin.a97161bb7adc762e49f6b7907a49ff48.svg";
export { ForwardRef as ReactComponent };